// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconRectangleLines } from '@ni/nimble-components/dist/esm/icons/rectangle-lines';
import { wrap } from '../utilities/react-wrapper';

export { type IconRectangleLines };
export const NimbleIconRectangleLines = wrap(IconRectangleLines);